import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { observer } from 'mobx-react';

interface ImgModalProps {
  visible: boolean;
  src: string;
  close: () => void;
}

const ImgModal = observer((props: ImgModalProps) => {
  const { visible, src, close } = props;

  return (
    <Container className={visible ? '' : 'close'} onClick={close}>
      <CloseOutlined onClick={() => close()} />
      <img src={src} alt="" />
    </Container>
  )
})

export default ImgModal;

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  img {
    max-width: 80%;
    max-height: 80%;
  }

  .anticon-close {
    position: absolute;
    top: 30px;
    right: 30px;
    color: #fff;
    font-size: 30px;
  }

  &.close{
    display: none;
  }
`
